import Alpine from "alpinejs";
import { formatNumberWithCommas } from "../../_utils/numbers";

export const alpineDirectiveCommas = () => {
  Alpine.directive(
    "commas",
    (el, { expression }, { evaluateLater, effect }) => {
      let getNumber = evaluateLater(expression);

      effect(() => {
        getNumber((number) => {
          el.innerHTML = formatNumberWithCommas(number);
        });
      });
    }
  );
};
